import { render, staticRenderFns } from "./editorIP.vue?vue&type=template&id=643f1f5c&scoped=true&"
import script from "./editorIP.vue?vue&type=script&lang=js&"
export * from "./editorIP.vue?vue&type=script&lang=js&"
import style0 from "./editorIP.vue?vue&type=style&index=0&id=643f1f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f1f5c",
  null
  
)

export default component.exports